<div class="fz-sort-by__root">
  @if (appearance === 'default') {
    <label for="sort-select" class="mat-label-large font-color--tertiary">
      {{ label }}:
    </label>
  }
  <button
    id="sort-select"
    class="fz-sort-by__select"
    [class.fz-sort-by--appearance-icon]="appearance === 'icon'"
    matTooltip="Sort by"
    mat-button
    [matMenuTriggerFor]="filterByMenu"
  >
    @if (appearance === 'default') {
      <ng-container>
        <span class="fz-sort-by__button_text">
          {{ sortBy() }} <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </span>
      </ng-container>
    }
    @if (appearance === 'icon') {
      <ng-container>
        <mat-icon iconPositionEnd>sort</mat-icon>
      </ng-container>
    }
  </button>
</div>

<mat-menu #filterByMenu="matMenu" class="fz-sort-by__menu">
  @for (item of items(); track item.value) {
    <button mat-menu-item (click)="onSortChange(item)">{{ item.name }}</button>
  }
</mat-menu>
